
export default {
  name: 'BbToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    activeColor: {
      type: String,
      default: '#4e226e',
    },
    inactiveColor: {
      type: String,
      default: '#e8e7e5',
    },
  },
  computed: {
    syncedValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
};
